module.exports = new __parcel__URL__("medical_academy_level_4.3ca4b4d1.png").toString();